/*
  Tablya : fiche produit (chargé en defer depuis sections/main-product.liquid).
  1. <tablya-barre-achat> : barre d'achat collante sur mobile. Elle apparaît quand le bouton principal
     « Ajouter au panier » est sorti de l'écran par le haut, recopie son libellé, son état et le prix affiché,
     et clique sur lui : le formulaire Dawn (panier, erreurs, notification) fait le reste.
  2. Numéro de la photo affichée (« 2 / 5 ») sur la grande image, pour la galerie à vignettes.
  3. Ligne de disponibilité du bloc « Disponibilité et livraison » : suit la variante choisie
     (événement variantChange de Dawn, HTML rendu par Shopify, rien n'est calculé ici).
     Combinaison inexistante : la ligne est masquée par le CSS avec le prix (tablya-product.css, :has).
  4. Zoom ×1,9 au survol de la grande photo, qui suit la souris (maquette), à la place de la loupe au clic
     de Dawn (magnify.js). Souris seulement, et rien si « réduire les animations » est actif : Dawn reprend la main.
  Aucun prix n'est calculé en JS : la barre recopie le prix rendu par Shopify (M3-S04).
*/
(function () {
  'use strict';

  // La fenêtre d'ajout rapide de Dawn réexécute les scripts de la fiche : une seule initialisation
  if (window.TablyaProduit) return;
  window.TablyaProduit = {};

  var reduit = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  /* ---------- 1. Barre d'achat collante ---------- */
  if (!customElements.get('tablya-barre-achat')) {
    customElements.define(
      'tablya-barre-achat',
      class extends HTMLElement {
        connectedCallback() {
          var section = this.dataset.section;
          this.boutonPrincipal = document.getElementById('ProductSubmitButton-' + section);
          this.conteneurPrix = document.getElementById('price-' + section);
          this.bouton = this.querySelector('.tb-barre-achat__bouton');
          this.prix = this.querySelector('.tb-barre-achat__prix');
          this.montant = this.querySelector('.tb-barre-achat__montant');

          if (!this.boutonPrincipal || !this.bouton) {
            this.hidden = true;
            return;
          }

          this.synchroniser = this.synchroniser.bind(this);
          this.surClic = this.surClic.bind(this);
          this.bouton.addEventListener('click', this.surClic);

          // Visible seulement quand le bouton principal est passé au-dessus de l'écran (sous l'en-tête collant).
          // La zone observée descend très bas : l'état change exactement au passage du bord haut,
          // même si la page saute d'un coup du dessous au dessus du bouton (ancre, rechargement).
          if ('IntersectionObserver' in window) {
            var entete = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
            this.observateurVue = new IntersectionObserver(
              (entrees) => {
                var entree = entrees[entrees.length - 1];
                this.afficher(!entree.isIntersecting);
              },
              { rootMargin: -entete + 'px 0px 100000px 0px' }
            );
            this.observateurVue.observe(this.boutonPrincipal);
          }

          // Même libellé, même état (rupture, chargement) et même prix que la fiche
          this.observateurEtat = new MutationObserver(this.synchroniser);
          this.observateurEtat.observe(this.boutonPrincipal, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
            childList: true,
            subtree: true,
            characterData: true,
          });
          if (this.conteneurPrix) {
            this.observateurEtat.observe(this.conteneurPrix, {
              attributes: true,
              attributeFilter: ['class'],
              childList: true,
              subtree: true,
              characterData: true,
            });
          }

          // Erreur d'ajout (stock insuffisant…) après un clic dans la barre : on fait défiler jusqu'au message
          var formulaire = this.boutonPrincipal.closest('product-form');
          this.erreur = formulaire ? formulaire.querySelector('.product-form__error-message-wrapper') : null;
          if (this.erreur) {
            this.observateurErreur = new MutationObserver(() => {
              if (this.erreur.hidden || !this.dernierClic || Date.now() - this.dernierClic > 8000) return;
              this.dernierClic = 0;
              this.erreur.scrollIntoView({
                behavior: reduit && reduit.matches ? 'auto' : 'smooth',
                block: 'center',
              });
            });
            this.observateurErreur.observe(this.erreur, { attributes: true, attributeFilter: ['hidden'] });
          }

          this.synchroniser();
        }

        disconnectedCallback() {
          [this.observateurVue, this.observateurEtat, this.observateurErreur].forEach(function (observateur) {
            if (observateur) observateur.disconnect();
          });
          if (this.bouton && this.surClic) this.bouton.removeEventListener('click', this.surClic);
          if (!document.querySelector('tablya-barre-achat.est-visible')) {
            document.documentElement.classList.remove('tb-barre-visible');
          }
        }

        afficher(visible) {
          this.classList.toggle('est-visible', visible);
          document.documentElement.classList.toggle('tb-barre-visible', visible);
        }

        synchroniser() {
          var principal = this.boutonPrincipal;

          var libelle = principal.querySelector('span');
          var texte = libelle ? libelle.textContent.trim() : '';
          if (texte && this.bouton.textContent.trim() !== texte) this.bouton.textContent = texte;

          this.bouton.disabled = principal.disabled;
          if (principal.getAttribute('aria-disabled') === 'true') {
            this.bouton.setAttribute('aria-disabled', 'true');
          } else {
            this.bouton.removeAttribute('aria-disabled');
          }

          if (!this.conteneurPrix || !this.montant) return;
          var prix = this.conteneurPrix.querySelector('.price');
          var element = null;
          if (prix) {
            element = prix.classList.contains('price--on-sale')
              ? prix.querySelector('.price__sale .price-item--last')
              : prix.querySelector('.price__regular .price-item--regular');
          }
          var cache = !element || this.conteneurPrix.classList.contains('hidden');
          if (this.prix) this.prix.classList.toggle('tb-barre-achat__prix--vide', cache);
          if (element) {
            var montant = element.textContent.trim();
            if (this.montant.textContent.trim() !== montant) this.montant.textContent = montant;
          }
        }

        surClic() {
          if (this.bouton.disabled || this.bouton.getAttribute('aria-disabled') === 'true') return;
          if (this.boutonPrincipal.disabled) return;
          this.dernierClic = Date.now();
          this.boutonPrincipal.click();
        }
      }
    );
  }

  /* ---------- 2. Numéro de la photo affichée ---------- */
  function numeroter(galerie) {
    if (!galerie || !galerie.closest('.tb-page-produit') || galerie.closest('quick-add-modal')) return;
    var liste = galerie.querySelector('[id^="Slider-Gallery"]');
    if (!liste) return;

    var elements = Array.prototype.filter.call(liste.children, function (element) {
      return element.hasAttribute('data-media-id') && !element.classList.contains('hidden');
    });
    var numero = galerie.querySelector('.tb-produit__numero');
    if (elements.length < 2) {
      if (numero) numero.remove();
      return;
    }

    var actif = liste.querySelector(':scope > .is-active') || elements[0];
    if (!numero) {
      numero = document.createElement('span');
      numero.className = 'tb-produit__numero';
      numero.setAttribute('aria-hidden', 'true'); // la galerie Dawn annonce déjà la photo chargée
    }
    var cadre = actif.querySelector('.product-media-container') || actif;
    if (numero.parentNode !== cadre) cadre.appendChild(numero);
    numero.textContent = elements.indexOf(actif) + 1 + ' / ' + elements.length;
  }

  function numeroterTout(racine) {
    var base = racine && racine.querySelectorAll ? racine : document;
    base.querySelectorAll('.tb-page-produit media-gallery').forEach(numeroter);
  }

  // Clic (ou Entrée) sur une vignette : la galerie Dawn a déjà changé la photo active
  document.addEventListener('click', function (event) {
    var galerie = event.target && event.target.closest ? event.target.closest('media-gallery') : null;
    if (galerie) {
      window.setTimeout(function () {
        numeroter(galerie);
      }, 0);
    }
  });

  // Section rechargée dans l'éditeur de thème
  document.addEventListener('shopify:section:load', function (event) {
    numeroterTout(event.target);
  });

  // Produit remplacé en entier (produits combinés) : Dawn remplace <main>
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (noeud) {
          if (noeud.nodeType === 1) numeroterTout(noeud);
        });
      });
    }).observe(document.body, { childList: true });
  }

  numeroterTout(document);

  /* ---------- 3. Changement de variante ---------- */
  function majDepuisHtml(donnees) {
    if (!donnees || !donnees.html || !donnees.sectionId) return;
    ['TablyaStock'].forEach(function (prefixe) {
      var source = donnees.html.getElementById(prefixe + '-' + donnees.sectionId);
      if (!source) return;
      // Sur la page, puis dans la fenêtre d'ajout rapide (Dawn y préfixe les identifiants par « quickadd- »)
      [prefixe + '-' + donnees.sectionId, prefixe + '-quickadd-' + donnees.sectionId].forEach(function (id) {
        var cible = document.getElementById(id);
        // Même produit seulement : l'ajout rapide peut afficher une autre fiche avec le même identifiant de section
        if (cible && source.dataset.produit === cible.dataset.produit) cible.innerHTML = source.innerHTML;
      });
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evenement) {
      majDepuisHtml(evenement && evenement.data);
      // La galerie remet la photo de la variante en premier
      window.setTimeout(numeroterTout, 0);
    });
  }

  /* ---------- 4. Zoom au survol de la grande photo ---------- */
  var ZOOM = 1.9;
  var pointeurFin = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;

  function zoomPermis() {
    return !!(pointeurFin && pointeurFin.matches) && !(reduit && reduit.matches);
  }

  function cadreZoom(cible) {
    if (!cible || !cible.closest) return null;
    var image = cible.closest('img.image-magnify-hover');
    if (!image || !image.closest('.tb-page-produit') || image.closest('quick-add-modal')) return null;
    return image.closest('.product__media');
  }

  function placerZoom(cadre, image, event) {
    var zone = cadre.getBoundingClientRect();
    if (!zone.width || !zone.height) return;
    var x = Math.min(Math.max((event.clientX - zone.left) / zone.width, 0), 1) * 100;
    var y = Math.min(Math.max((event.clientY - zone.top) / zone.height, 0), 1) * 100;
    image.style.transformOrigin = x + '% ' + y + '%';
    image.style.transform = 'scale(' + ZOOM + ')';
  }

  document.addEventListener('mouseover', function (event) {
    if (!zoomPermis()) return;
    var cadre = cadreZoom(event.target);
    if (!cadre) return;
    var image = cadre.querySelector('img.image-magnify-hover');
    if (!image) return;
    // La loupe au clic de Dawn (posée par magnify.js) ferait doublon avec le zoom au survol
    image.onclick = null;
    if (cadre.dataset.tbZoom) return;
    cadre.dataset.tbZoom = '1';
    cadre.classList.add('tb-zoom');
    // L'image est relue à chaque fois : Dawn peut la remplacer au changement de variante
    cadre.addEventListener('mousemove', function (e) {
      var actuelle = cadre.querySelector('img.image-magnify-hover');
      if (actuelle && zoomPermis()) placerZoom(cadre, actuelle, e);
    });
    cadre.addEventListener('mouseleave', function () {
      var actuelle = cadre.querySelector('img.image-magnify-hover');
      if (actuelle) actuelle.style.transform = '';
    });
    placerZoom(cadre, image, event);
  });

  /* ---------- 5. Une couleur = ses photos ---------- */
  // Chaque photo porte sa couleur (data-tb-couleur, snippets/tb-couleur-media.liquid). On masque
  // celles des autres couleurs : au chargement, puis à chaque changement de variante.
  function filtrerCouleur(galerie, couleur) {
    if (!galerie || !couleur) return;
    couleur = String(couleur).toLowerCase();
    // Aucune photo de cette couleur : on ne masque rien plutôt que de vider la galerie
    if (!galerie.querySelector('[data-tb-couleur="' + couleur.replace(/"/g, '') + '"]')) return;
    galerie.querySelectorAll('[data-tb-couleur]').forEach(function (element) {
      element.classList.toggle('hidden', element.getAttribute('data-tb-couleur') !== couleur);
    });
    numeroter(galerie);
  }

  function filtrerTout(variante) {
    document.querySelectorAll('media-gallery[data-tb-index]').forEach(function (galerie) {
      var couleur = variante && variante.options
        ? variante.options[Number(galerie.getAttribute('data-tb-index'))]
        : galerie.getAttribute('data-tb-choisie');
      filtrerCouleur(galerie, couleur);
    });
  }

  filtrerTout(null);
  document.addEventListener('shopify:section:load', function () {
    filtrerTout(null);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evenement) {
      var variante = evenement && evenement.data && evenement.data.variant;
      window.setTimeout(function () {
        filtrerTout(variante);
      }, 0);
    });
  }

  window.TablyaProduit.numeroter = numeroterTout;
})();
